export default __webpack_public_path__ + "static/media/Mark-2-Suit-Cycles-01.c406b560.jpg";